<template>
  <el-dialog
    :visible="true"
    width="737px"
    :close-on-click-modal="false"
    @close="$router.replace('/ntax-partners')"
  >
    <div slot="title">
      NTAX partner módosítása
      <el-tag
        v-if="ntaxPartner.is_customer"
        size="small"
        type="success"
        style="margin-right: 5px;"
      >
        Vevő
      </el-tag>
      <el-tag
        v-if="ntaxPartner.is_supplier"
        size="small"
        type="primary"
      >
        Beszállító
      </el-tag>
    </div>
    <el-form
      ref="ntaxPartnerForm"
      v-loading="loading"
      :model="ntaxPartner"
      :rules="ntaxPartner"
      label-position="top"
      autocomplete="off"
      @submit.native.prevent="add"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            prop="name"
            label="Név"
          >
            <el-input
              v-model="ntaxPartner.company.name"
              disabled
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="tax_number"
            label="Adószám"
          >
            <el-input
              v-model="ntaxPartner.ntax_partner.tax_number"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            prop="custom_name"
            label="Egyedi NTAX név"
          >
            <el-input
              v-model="ntaxPartner.ntax_partner.custom_name"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="store_in_txt"
            label="Exportálandó"
          >
            <el-select
              v-model="ntaxPartner.ntax_partner.store_in_txt"
              style="width: 100%;"
            >
              <el-option
                label="Igen"
                :value="true"
              />
              <el-option
                label="Nem"
                :value="false"
              />
              <el-option
                label="Nincs megadva"
                :value="null"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" v-if="ntaxPartner.is_supplier">
          <el-form-item
            prop="ntax_code"
            label="NTAX kód"
          >
            <el-input
              v-model="ntaxPartner.ntax_partner.supplier_ntax_code"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="ntaxPartner.is_customer">
          <el-form-item
            prop="ntax_code"
            label="Vevő NTAX kód"
          >
            <el-input
              v-model="ntaxPartner.ntax_partner.ntax_code"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="ntaxPartner.is_supplier">
          <el-form-item
            prop="web_ntax_code"
            label="Web NTAX kód"
          >
            <el-input
              v-model="ntaxPartner.ntax_partner.web_ntax_code"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="ntaxPartner.is_supplier">
        <el-col :span="12">
          <el-form-item
            prop="job_number"
            label="Munkaszám"
          >
            <el-input
              v-model="ntaxPartner.ntax_partner.job_number"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="cost_centre"
            label="Költséghely"
          >
            <el-input
              v-model="ntaxPartner.ntax_partner.cost_centre"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="$router.replace('/ntax-partners')">
        Mégse
      </el-button>
      <el-button
        type="primary"
        :loading="buttonLoading"
        @click="add"
      >
        Módosítás
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ['type', 'ntaxPartnerId'],
  data() {
    return {
      loading: false,
      buttonLoading: false,
      ntaxPartner: {
        company: {},
        ntax_partner: {
          store_in_txt: null,
          tax_number: '',
        },
      },
      rules: {
        name: [
          { required: true, message: 'Név megadása kötelező', trigger: 'blur' }
        ],
      },
    }
  },
  async mounted() {
    this.loading = true;
    const data = await axios.get('api/ntax-partners/' + this.ntaxPartnerId);
    data.ntax_partner = data.ntax_partner || {
      store_in_txt: null,
    };
    data.ntax_partner.tax_number = data.company.tax_number;
    this.ntaxPartner = data;
    this.loading = false;
  },
  methods: {
    async add() {
      this.$refs['ntaxPartnerForm'].validate(async valid => {
        if (valid) {
          this.buttonLoading = true;
          try {
            await axios.put('api/ntax-partners', this.ntaxPartner);
            this.$store.dispatch('ntaxPartner/fetchAll');
            this.$router.replace('/ntax-partners');
          } catch (e) {
          }
          this.buttonLoading = false;
        }
      });
    }
  },
}
</script>
